<template>
    <Main @hideAll="hideAll" v-if="hideAllBool"/>
</template>

<script>

import { mapActions } from 'vuex';
import Main from './views/Main';

const actions = [
    'resize',
];

export default {
    name: 'App',
    data: () => ({
        width: window.innerWidth,
        hideAllBool: true,
    }),
    components: {
        Main,
    },
    methods: {
        ...mapActions(actions),
        hideAll(){
            this.hideAllBool = false;
        },
    },
    created() {
        window.addEventListener('resize', this.resize);
        this.resize();
    },
};
</script>

<style lang="scss">
  @import 'fonts/FuturaPT.css';
  @import 'fonts/Montserrat.css';
  @import 'fonts/OpenSans.css';

  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }
  * {
    margin: 0;
    padding: 0;
  }
  // a{
  //   font-size: 12px;
  //   color: #63B5E6;
  //   text-decoration: underline;
  // }
  .desktop-main{
    background-color: #fcfcfe;
    background-image: url(./assets/bg-map.png);
    background-size: contain;
    background-attachment: fixed;
    background-repeat: no-repeat;
    width: 100vw;
    height: 100vh;
  }

  
</style>